module.exports = __webpack_public_path__ + "static/media/maxim.29e4eb40.jpeg";